import { LogManager } from 'core/logging/LogManager';
import { httpClient } from 'core/net/http';
import * as v from 'valibot';

const logger = LogManager.getLogger('fetchBlastingScenarios', { error: { logToServer: true } });

export async function fetchBlastingScenarios() {
  const response = await httpClient.useInternalApi.asAuthorised().post('blasting/scenarios', {});

  if (!response.isSuccess) {
    const errorMessage = 'Failed to fetch blasting scenarios';
    logger.error(errorMessage);
    throw new Error(errorMessage);
  }

  const parsedData = v.safeParse(BlastScenarioSummaryResponseSchema, response.data);

  if (!parsedData.success) {
    const errorMessage = 'Failed to parse blasting scenarios response';
    logger.error(errorMessage, parsedData.issues);
    throw new Error(errorMessage);
  }

  return parsedData.output.blastScenarioSummaries;
}

export const BlastScenarioSummarySchema = v.object({
  alias: v.string(),
  name: v.string(),
  utcLastUpdatedTime: v.string(),
  utcActualBlastTime: v.nullable(v.string()),
  utcFirstScenarioTime: v.nullable(v.string()),
});

export const BlastScenarioSummaryResponseSchema = v.object({
  blastScenarioSummaries: v.array(BlastScenarioSummarySchema),
});
